// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","buttonContainer":"SectionHero_buttonContainer__HCqtI","browse":"SectionHero_browse__Zowk4"};